module.exports = __webpack_public_path__ + "img/ico_top_04.37103072.png";